const PATRON_AFTER_PAYMENT_PATH_KEY = "patronAfterPaymentPath";
const PATRON_FIUU_PAYMENT_RETURN_KEY = "patronFiuuPaymentReturnUrl";

export function savePatronAfterPaymentPath(path: string): void {
  sessionStorage.setItem(PATRON_AFTER_PAYMENT_PATH_KEY, path);
}

export function consumePatronAfterPaymentPath(fallbackPath?: string): string {
  const path =
    sessionStorage.getItem(PATRON_AFTER_PAYMENT_PATH_KEY) || fallbackPath || "";

  sessionStorage.removeItem(PATRON_AFTER_PAYMENT_PATH_KEY);

  return path;
}

export function savePatronFiuuPaymentReturnUrl(url: string): void {
  sessionStorage.setItem(PATRON_FIUU_PAYMENT_RETURN_KEY, url);
}

export function getPatronFiuuPaymentReturnUrl(): string | null {
  return sessionStorage.getItem(PATRON_FIUU_PAYMENT_RETURN_KEY);
}
